import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
    mutation ChangeCurrencyMutation(
    $input: EditPersonalProfileInput!
    ) {
        editPersonalProfile(input: $input) {
            user {
                profile {
                    currency
                }
            }
        }
    }
`;

const getOptimisticResponse = (id, currency) => ({
    editPersonalProfile: {
        user: {
            id,
            profile: {
                currency
            }
        }
    }
});

const changeCurrency = ({environment, user, currency, onCompleted}) => {

    const {id, serviceId} = user;

    return commitMutation(
        environment, {
            mutation,
            variables: {
                input: {
                    userServiceId: serviceId,
                    currency: currency
                }
            },
            optimisticResponse: () => getOptimisticResponse(id, currency),
            onCompleted
        }
    );
};

export default {commit: changeCurrency};



// WEBPACK FOOTER //
// ./src/components/Footer/CurrencySelector/ChangeCurrencyMutation.js